/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'eye': {
    viewBox: '3 3 18 18',
    data: '<path d="M11.934,19.005c-5.873,0-8.774-6.483-8.895-6.759l-.1-.241.1-.241c.121-.276,3.022-6.759,8.9-6.759s8.774,6.483,8.9,6.759l.105.241-.105.241C20.708,12.522,17.806,19.005,11.934,19.005ZM4,12.005c.573,1.14,3.259,5.923,7.937,5.923s7.363-4.783,7.936-5.923c-.573-1.14-3.259-5.923-7.936-5.923S4.57,10.865,4,12.005Z"/><circle cx="11.934" cy="12.005" r="2.308"/>'
  }
})
